export default class VIPContactViewModel {
    public id: number;
    public userEmail: string;
    public name: string;
    public phoneNumber: string;
}
